import { api } from "../client";
import {
  FavoriteExtraFields,
  FavoriteFields,
  PartialFavoriteExtraFields,
  PartialFavoriteFields,
} from "../schema/Favorite";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<FavoriteFields, FavoriteExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialFavoriteFields,
  PartialFavoriteExtraFields
>;

export const getFavorites = async (config?: ApiRequestConfig) => {
  return api.get<FavoriteFields, FavoriteExtraFields>("favorites", config);
};
export const getFavorite = (id: number, config?: ApiRequestConfig) => {
  return api.get<FavoriteFields, FavoriteExtraFields>(
    `favorites/${id}`,
    config
  );
};

export const createFavorite = (config: ApiRequestConfigMutate) => {
  return api.create<PartialFavoriteFields, PartialFavoriteExtraFields>(
    "favorites",
    config
  );
};
export const updateFavorite = (id: number, config?: ApiRequestConfigMutate) => {
  return api.update<PartialFavoriteFields, PartialFavoriteExtraFields>(
    `favorites/${id}`,
    config
  );
};
export const deleteFavorite = (id: number) => {
  return api.remove<FavoriteFields, FavoriteExtraFields>(`favorites/${id}`);
};
